"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initGoogleAnalytics = initGoogleAnalytics;
exports.initFirebaseAnalytics = initFirebaseAnalytics;
exports.setVehicleProgram = setVehicleProgram;
exports.getVehicleProgram = getVehicleProgram;
exports.setApplicationType = setApplicationType;
exports.setBrand = setBrand;
exports.setTypeSubType = setTypeSubType;
exports.setYearDimension = setYearDimension;
exports.trackScreenView = trackScreenView;
exports.trackVideoView = trackVideoView;
exports.trackVideoChapterClick = trackVideoChapterClick;
exports.trackTextView = trackTextView;
exports.trackSearchKeyword = trackSearchKeyword;
exports.trackVehicleSearchKeyword = trackVehicleSearchKeyword;
exports.trackSearchResultsTopicClick = trackSearchResultsTopicClick;
exports.trackVehicleSearchResultsClick = trackVehicleSearchResultsClick;
exports.trackEmptyResultsSearchKeyword = trackEmptyResultsSearchKeyword;
exports.trackEmptyVehicleSearchResults = trackEmptyVehicleSearchResults;
exports.trackExploreSceneClick = trackExploreSceneClick;
exports.trackExploreTopicClick = trackExploreTopicClick;
exports.trackBrowseFolderClick = trackBrowseFolderClick;
exports.trackBrowseTopicClick = trackBrowseTopicClick;
exports.trackTopPicksTopicClick = trackTopPicksTopicClick;
exports.trackPublicationFolderClick = trackPublicationFolderClick;
exports.trackPublicationTopicClick = trackPublicationTopicClick;
exports.trackPublicationClick = trackPublicationClick;
exports.trackFavoritesTopicAdded = trackFavoritesTopicAdded;
exports.trackRecentlyViewedTopicClick = trackRecentlyViewedTopicClick;
exports.trackTopicRatingUpvote = trackTopicRatingUpvote;
exports.trackTopicRatingDownvote = trackTopicRatingDownvote;
exports.trackChangeVehicleClick = trackChangeVehicleClick;
exports.trackRelatedTopicClick = trackRelatedTopicClick;
exports.trackAttachmentIconClick = trackAttachmentIconClick;
exports.trackPdfClick = trackPdfClick;
exports.trackPdfTabClick = trackPdfTabClick;
exports.trackVideoClick = trackVideoClick;
exports.trackVideoTabClick = trackVideoTabClick;
exports.trackDownloadClick = trackDownloadClick;
exports.trackSkipDownloadClick = trackSkipDownloadClick;
exports.trackDownloadOwnersManualPDF = trackDownloadOwnersManualPDF;
exports.trackNextTopicClick = trackNextTopicClick;
exports.trackPreviousTopicClick = trackPreviousTopicClick;
exports.trackHomeFolderClick = trackHomeFolderClick;
exports.trackOwnerManualFolderClick = trackOwnerManualFolderClick;
exports.trackComponentManualFolderClick = trackComponentManualFolderClick;
exports.trackVideosFolderClick = trackVideosFolderClick;
exports.trackContentView = trackContentView;
exports.trackContentViewByType = trackContentViewByType;
exports.trackContentViewPdf = trackContentViewPdf;
exports.trackContentViewVideo = trackContentViewVideo;
exports.trackContentViewArticle = trackContentViewArticle;
exports.trackWarningLightsIconClick = trackWarningLightsIconClick;

var _trackerGoogleAnalytics = _interopRequireWildcard(require("./trackerGoogleAnalytics"));

var _trackerFirebaseAnalytics = _interopRequireDefault(require("./trackerFirebaseAnalytics"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var tracker = null;
/**
 * Initializes analytics tracker instance
 *
 * @param {String} trackerId
 */

function initGoogleAnalytics(trackerId) {
  tracker = new _trackerGoogleAnalytics["default"](trackerId);
}
/**
 * Initializes analytics tracker instance
 *
 * @param {Object} firebaseConfig
 */


function initFirebaseAnalytics(firebaseConfig) {
  tracker = new _trackerFirebaseAnalytics["default"](firebaseConfig);
}
/**
 * Updates the GA context with vehicle program dimension data
 *
 * "dimension1" is configured as "Vehicle Program" dimension
 *
 * @param {String} year
 * @param {String} brand
 * @param {String} model
 */


function setVehicleProgram(year, brand, model) {
  var vehicleProgramString = year + ' ' + brand + ' ' + model;
  tracker.set(_defineProperty({}, _trackerGoogleAnalytics.CUSTOM_DIMENSION_MAP['dimension1'], vehicleProgramString));
}
/**
 * Returns vehicle program if it was previously set with setVehicleProgram()
 *
 * This is a workaround for limitations of vehicle selector that doesn't allows you to read prior model/year
 *
 * TODO: remove this method when the vehicle selector in Subaru StarLink & ForestRiver React Native app is refactored
 *
 * @return {String}
 */


function getVehicleProgram() {
  try {
    return tracker.getCustomDimensions()['dimension1'];
  } catch (e) {
    return null; // if we can't fetch the vehicle program data then empty value should be returned
  }
}
/**
 * Updates the GA context with application type (web/mobile/ivh/desktop/native/etc...)
 *
 * "dimension2" GA dimension should be configured as "Application Type"
 *
 * @param {String} type
 */


function setApplicationType(type) {
  tracker.set(_defineProperty({}, _trackerGoogleAnalytics.CUSTOM_DIMENSION_MAP['dimension2'], type));
}
/**
 * Updates the GA context with application brand (some clients produce products under different brands)
 *
 * "dimension3" GA dimension should be configured as "Brand"
 *
 * @param {String} brand
 */


function setBrand(brand) {
  tracker.set(_defineProperty({}, _trackerGoogleAnalytics.CUSTOM_DIMENSION_MAP['dimension3'], brand));
}
/**
 * Updates the GA context with application type and subtype
 *
 * "dimension4" GA dimension should be configured as "Type + SubType"
 *
 * @param {String} type
 * @param {String} subtype
 */


function setTypeSubType(type, subtype) {
  tracker.set(_defineProperty({}, _trackerGoogleAnalytics.CUSTOM_DIMENSION_MAP['dimension4'], type + ': ' + subtype));
}
/**
 * Updates the GA context with year
 *
 * "dimension5" GA dimension should be configured as "Model Year"
 *
 * @param {String} year
 */


function setYearDimension(year) {
  tracker.set(_defineProperty({}, _trackerGoogleAnalytics.CUSTOM_DIMENSION_MAP['dimension5'], year));
}
/**
 * Tracks screen/page views during navigation across the app
 *
 * @param {String} location
 */


function trackScreenView(location) {
  tracker.screen(location);
}
/**
 * Tracks video views
 *
 * @param {String} title - video topic title
 */


function trackVideoView(title) {
  tracker.event({
    category: 'Content',
    action: 'Video Play',
    label: title
  });
}
/**
 * Tracks video views
 *
 * @param {String} title - topic title + chapter title to differentiate chapters from different videos and the same name
 */


function trackVideoChapterClick(title) {
  tracker.event({
    category: 'Content',
    action: 'Chapter Play',
    label: title
  });
}
/**
 * Track text topic views - text topic title
 *
 * @param {String} title
 */


function trackTextView(title) {
  tracker.event({
    category: 'Content',
    action: 'View Text',
    label: title
  });
}
/**
 * Tracks search keywords
 *
 * @param {String} keyword
 */


function trackSearchKeyword(keyword) {
  tracker.event({
    category: 'Search',
    action: 'Keyword Search',
    label: keyword
  });
}
/**
 * Tracks vehicle search keywords
 *
 * @param {String} keyword
 */


function trackVehicleSearchKeyword(keyword) {
  tracker.event({
    category: 'Vehicle Search',
    action: 'Keyword Search',
    label: keyword
  });
}
/**
 * Tracks topic name that was clicked in the search results
 *
 * @param {String} title
 * @param {String} [searchQuery]
 */


function trackSearchResultsTopicClick(title) {
  var searchQuery = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var label = searchQuery ? "".concat(title, " :: ").concat(searchQuery) : title;
  tracker.event({
    category: 'Search',
    action: 'Search Result Click',
    label: label
  });
}
/**
 * Tracks vehicle that was clicked in the vehicle search results
 *
 * @param {String} vehicle
 * @param {String} searchQuery
 */


function trackVehicleSearchResultsClick(vehicle, searchQuery) {
  var label = "".concat(vehicle, " :: ").concat(searchQuery);
  tracker.event({
    category: 'Vehicle Search',
    action: 'Result Click',
    label: label
  });
}
/**
 * Tracks empty search results for keywords
 *
 * @param {String} keyword
 */


function trackEmptyResultsSearchKeyword(keyword) {
  tracker.event({
    category: 'Search',
    action: 'Empty Search Results',
    label: keyword
  });
}
/**
 * Tracks empty vehicle search for a keyword
 *
 * @param {String} keyword
 */


function trackEmptyVehicleSearchResults(keyword) {
  tracker.event({
    category: 'Vehicle Search',
    action: 'Empty Results',
    label: keyword
  });
}
/**
 * Tracks visual search scene clicks
 *
 * @param {String} title
 */


function trackExploreSceneClick(title) {
  tracker.event({
    category: 'Explore',
    action: 'Scene Click',
    label: title
  });
}
/**
 * Tracks visual search topic clicks
 *
 * @param {String} title
 */


function trackExploreTopicClick(title) {
  tracker.event({
    category: 'Explore',
    action: 'Topic Click',
    label: title
  });
}
/**
 * Tracks browse folder clicks
 *
 * @param {String} title
 */


function trackBrowseFolderClick(title) {
  tracker.event({
    category: 'Browse',
    action: 'Category Click',
    label: title
  });
}
/**
 * Tracks browse topic clicks
 *
 * @param {String} title - topic title
 * @param {String} publication - publication which topic belongs to
 */


function trackBrowseTopicClick(title, publication) {
  tracker.event({
    category: 'Browse',
    action: 'Topic Click',
    label: "".concat(title, " :: ").concat(publication)
  });
}
/**
 * Tracks top picks topic clicks
 *
 * @param {String} title
 */


function trackTopPicksTopicClick(title) {
  tracker.event({
    category: 'Promoted',
    action: 'Topic Click',
    label: title
  });
}
/**
 * Tracks folder clicks per publication
 *
 * @param {String} publication
 * @param {String} title
 */


function trackPublicationFolderClick(publication, title) {
  tracker.event({
    category: publication,
    action: 'Category Click',
    label: title
  });
}
/**
 * Tracks topic clicks per publication
 *
 * @param {String} publication
 * @param {String} title
 */


function trackPublicationTopicClick(publication, title) {
  tracker.event({
    category: publication,
    action: 'Topic Click',
    label: title
  });
}
/**
 * Track top level publication
 *
 * @param {String} publication
 * @param {String} title
 */


function trackPublicationClick(publication, title) {
  tracker.event({
    category: publication,
    action: 'Publication Click',
    label: title
  });
}
/**
 * Tracks adding topic to favorites
 *
 * @param {String} title
 */


function trackFavoritesTopicAdded(title) {
  tracker.event({
    category: 'Favorites',
    action: 'Topic Added',
    label: title
  });
}
/**
 * Tracks clicks on recently viewed
 *
 * @param {String} title
 */


function trackRecentlyViewedTopicClick(title) {
  tracker.event({
    category: 'Recently Viewed',
    action: 'Topic Click',
    label: title
  });
}
/**
 * Tracks up-voting the topic
 *
 * @param {String} title
 */


function trackTopicRatingUpvote(title) {
  tracker.event({
    category: 'Topic Rating',
    action: 'Upvote',
    label: title
  });
}
/**
 * Tracks down-voting the topic
 *
 * @param {String} title
 */


function trackTopicRatingDownvote(title) {
  tracker.event({
    category: 'Topic Rating',
    action: 'Downvote',
    label: title
  });
}
/**
 * Tracks vehicle changes
 *
 * @param {String} beforeVehicle
 * @param {String} afterVehicle
 */


function trackChangeVehicleClick(beforeVehicle, afterVehicle) {
  tracker.event({
    category: 'Change Vehicle',
    action: 'Click',
    label: beforeVehicle + ' :: ' + afterVehicle
  });
}
/**
 * Tracks related topic click
 *
 * @param {String} fromTopic
 * @param {String} toTopic
 */


function trackRelatedTopicClick(fromTopic, toTopic) {
  tracker.event({
    category: 'Related Topic',
    action: 'Topic Click',
    label: fromTopic + ' :: ' + toTopic
  });
}
/**
 * Tracks attachment icon click
 *
 * @param {String} topicName
 */


function trackAttachmentIconClick(topicName) {
  tracker.event({
    category: 'Attachments',
    action: 'Clicks',
    label: topicName
  });
}
/**
 * Tracks attachment PDF click
 *
 * @param {String} pdfName
 */


function trackPdfClick(pdfName) {
  tracker.event({
    category: 'Attachments',
    action: 'PDF Click',
    label: pdfName
  });
}
/**
 * Tracks PDF tab click
 *
 * @param {String} topicName
 */


function trackPdfTabClick(topicName) {
  tracker.event({
    category: 'Attachments',
    action: 'PDF Tab Click',
    label: topicName
  });
}
/**
 * Tracks attachment video click
 *
 * @param {String} videoName
 */


function trackVideoClick(videoName) {
  tracker.event({
    category: 'Attachments',
    action: 'Video Click',
    label: videoName
  });
}
/**
 * Tracks video tab click
 *
 * @param {String} topicName
 */


function trackVideoTabClick(topicName) {
  tracker.event({
    category: 'Attachments',
    action: 'Video Tab Click',
    label: topicName
  });
}
/**
 * Tracks download OM click
 *
 * @param {String} modelName
 */


function trackDownloadClick(modelName) {
  tracker.event({
    category: 'Download OM',
    action: 'Download Click',
    label: modelName
  });
}
/**
 * Tracks skip download OM click
 *
 * @param {String} modelName
 */


function trackSkipDownloadClick(modelName) {
  tracker.event({
    category: 'Download OM',
    action: 'Skip Click',
    label: modelName
  });
}
/**
 * Tracks download OM PDF click
 *
 * @param {String} model
 * @param {String} lang
 */


function trackDownloadOwnersManualPDF(model, lang) {
  tracker.event({
    category: 'Download OM PDF',
    action: 'Link Click',
    label: "".concat(model, " :: ").concat(lang)
  });
}
/**
 * Tracks next topic click
 *
 * @param {String} currentTopicName
 */


function trackNextTopicClick(currentTopicName) {
  tracker.event({
    category: 'Topic Navigation',
    action: 'Next Topic Click',
    label: currentTopicName
  });
}
/**
 * Tracks previous topic click
 *
 * @param {String} currentTopicName
 */


function trackPreviousTopicClick(currentTopicName) {
  tracker.event({
    category: 'Topic Navigation',
    action: 'Previous Topic Click',
    label: currentTopicName
  });
}
/**
 * Tracks click of the root folders/tags
 *
 * @param {String} name
 */


function trackHomeFolderClick(name) {
  tracker.event({
    category: 'Home',
    action: 'Folder Click',
    label: name
  });
}
/**
 * Tracks click of the folders/tags inside Owners Manual
 *
 * @param {String} name
 */


function trackOwnerManualFolderClick(name) {
  tracker.event({
    category: 'Home Owner Manual',
    action: 'Folder Click',
    label: name
  });
}
/**
 * Tracks click of the folders/tags inside Component Manual
 *
 * @param {String} name
 */


function trackComponentManualFolderClick(name) {
  tracker.event({
    category: 'Home Component Manual',
    action: 'Folder Click',
    label: name
  });
}
/**
 * Tracks click of the folders/tags inside Videos
 *
 * @param {String} name
 */


function trackVideosFolderClick(name) {
  tracker.event({
    category: 'Home Video',
    action: 'Folder Click',
    label: name
  });
}
/**
 * Tracks content view (new universal content views tracker for all content types)
 *
 * @param {String} name
 */


function trackContentView(name) {
  tracker.event({
    category: 'Content',
    action: 'Click',
    label: name
  });
}
/**
 * Tracks content view (new universal content views tracker for specific content type)
 *
 * @param {String} name
 * @param {String} contentType
 */


function trackContentViewByType(name, contentType) {
  tracker.event({
    category: 'Content',
    action: 'Click By Type',
    label: contentType + ':' + name
  });
}
/**
 * Tracks PDF content view
 *
 * @param {String} name
 */


function trackContentViewPdf(name) {
  tracker.event({
    category: 'Content',
    action: 'Pdf Click',
    label: name
  });
}
/**
 * Tracks Video content view
 *
 * @param {String} name
 */


function trackContentViewVideo(name) {
  tracker.event({
    category: 'Content',
    action: 'Video Click',
    label: name
  });
}
/**
 * Tracks Article content view
 *
 * @param {String} name
 */


function trackContentViewArticle(name) {
  tracker.event({
    category: 'Content',
    action: 'Article Click',
    label: name
  });
}

function trackWarningLightsIconClick(label) {
  tracker.event({
    category: 'Warning & Indicator Lights',
    action: 'Icon Clicked',
    label: label
  });
}